var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle",class:[_vm.checked ? 'toggle-active active' : 'toggle-inactive'],on:{"click":function($event){return _vm.toggleAction()}}},[_c('div',{staticClass:"toggle-rounded",attrs:{"type":"checkbox"}})])}
var staticRenderFns = []

export { render, staticRenderFns }